<div class="dialog-container text-grey">
    <div class="modal-header">
    <h4 class="header-title">{{data.dialogHeader}} to application {{data.application.appName}} ({{data.application.appVersionText}})</h4>
    <button class="close-button" (click)="onClose()">
    <mat-icon>close</mat-icon>
    </button>
    </div>

    <form [formGroup]="actionForm" (ngSubmit)="onSubmit()">
        <input type="text" formControlName="id" hidden>
        <input type="text" formControlName="appId" hidden>
    <mat-dialog-content class="modal-body pb-0" style="padding: 17px;">
            <div class="row g-3">
                <div class="col-6">
                    <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Action Name</mat-label>
                    <input matInput formControlName="actionName" placeholder="Enter action name">
                    <mat-error *ngIf="actionForm.get('actionName')?.errors?.['required']">
                        Action Name is required
                    </mat-error>
                    </mat-form-field>
                </div>
            
                <div class="col-6">
                    <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Params</mat-label>
                    <mat-select formControlName="param" multiple>
                        <mat-option *ngFor="let param of paramsList" [value]="param">
                        {{param.slice(1)}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="actionForm.get('param')?.errors?.['required']">
                        Params is required
                    </mat-error>
                    </mat-form-field>
                </div>
        
                <div class="col-6">
                    <mat-form-field appearance="fill" class="w-100">
                    <mat-label *ngIf="scriptPathList.length > 0">Script</mat-label>
                    <mat-label *ngIf="scriptPathList.length == 0" class="text-danger">Please Add Script</mat-label>
                    <mat-select formControlName="script">
                        <mat-option *ngIf="scriptPathList.length == 0" [disabled]="true" class="text-danger">Please Add Script for this Application</mat-option>
                        <mat-option *ngFor="let path of scriptPathList" [value]="path">
                        {{path}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="actionForm.get('script')?.errors?.['required']">
                        Script is required
                    </mat-error>
                    </mat-form-field>
                </div>
            
                <div class="col-6">
                    <mat-form-field appearance="fill" class="w-100">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="state" multiple>
                        <mat-option [value]="'Active'" >
                            Active
                        </mat-option>
                        <mat-option [value]="'Inactive'" disabled>
                            Inactive
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="actionForm.get('state')?.errors?.['required']">
                        State is required
                    </mat-error>
                    </mat-form-field>
                </div>
            
                <div class="col-6">
                    <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Stage</mat-label>
                    <mat-select formControlName="stage" multiple>
                        <mat-option [value]="defaultStage" disabled>
                        {{defaultStage}}
                        </mat-option>
                    </mat-select>
                    </mat-form-field>
                </div>
            
                <div class="col-6">
                    <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status" multiple>
                        <mat-option *ngFor="let status of statusList" [value]="status">
                        {{status}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="actionForm.get('status')?.errors?.['required']">
                        Status is required
                    </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-dialog-content>
        
        <mat-dialog-actions class="modal-footer d-flex justify-content-end">
            <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
            <button type="submit" class="btn btn-primary" [disabled]="!actionForm.valid" >
                {{data.dialogHeader.split(' ')[0]}}
            </button>
        </mat-dialog-actions>
    </form>

    <ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" color="var(--s-primary-color)" type="ball-spin"
    [fullScreen]="false" name="UpdateCustomAction">
    <p>Please wait ...</p>
  </ngx-spinner>
</div>
